import { env } from 'UTILS/env'

export const typeFileMap = {
  png: ['webp', 'jpeg', 'heic', 'avif', 'png'],
  webp: ['webp', 'jpeg', 'heic', 'avif', 'png'],
  jpg: ['webp', 'jpeg', 'heic', 'avif', 'png'],
  jpeg: ['webp', 'jpeg', 'heic', 'avif', 'png'],
  heic: ['webp', 'jpeg', 'heic', 'avif', 'png'],
  avif: ['webp', 'jpeg', 'heic', 'avif', 'png'],
  heif: ['awebp', 'heif', 'avis', 'gif'],
  gif: ['awebp', 'heif', 'avis', 'gif'],
  awebp: ['awebp', 'heif', 'avis', 'gif'],
  avis: ['awebp', 'heif', 'avis', 'gif'],
  cut: [],
}

export const staticArr = ['png', 'jpg', 'jpeg', 'webp', 'heic', 'avif']

export const activeArr = ['heif', 'gif', 'awebp', 'avis']

export const imageAccept = '.jpg,.jpeg,.png,.heic,.avif,.webp,.gif,.awebp,.heif,.avis'

export const watermarkAccept = '.jpg,.jpeg,.png,.heic,.webp,.avif'

export const uploaderTip = 'jpg/jpeg/png/heic/webp/avif/gif/awebp/heif/avis'

export enum DeviceType {
  TabLet = 'tablet',
  Mobile = 'mobile',
  Desktop = 'desktop',
}

export enum SlardarEventType {
  ImageDemotion = 'ImageDemotion',
  ImageLoad = 'ImageLoad',
  AnimImageTask = 'AnimImageTask',
  ImageUpload = 'ImageUpload',
  GlobalCatch = 'GlobalCatch',
}

export const Error = {
  CheckError: 'CheckError',
}

export const EXPIRE_TIME = env.isProd ? 60 * 60 * 1000 : Number.MAX_SAFE_INTEGER

export const LOOP_TIME = 10 * 1000
